module.exports = {
      id: "production-icon-usage",
      viewBox: "0 0 58 52",
      url: __webpack_public_path__ + "sprite-b16b2d73f82c96a320ba0490c6416430.svg#production-icon",
      toString: function () {
        return this.url;
      }
    }